module.exports = __webpack_public_path__ + "img/kitchen-dining-accent-chairs.f38ff5f.jpg";